import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./style.css";
import axios from 'axios';
import logo from "./logo_black.png";
import { Helmet } from "react-helmet";
// Same origin, like every other screen: nginx proxies /api and /auth to the backend on both
// ports, and an absolute http:// URL is blocked as mixed content the moment the site answers
// on https (2026-09-02). See backendConfig.js.
import { BACKEND_URL } from './backendConfig';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://13.67.118.92:5000";


function ResetPasswordRequest() {
    const { t } = useTranslation();
    const [username, setUsername] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError('');
        setMessage('');

        try {
            const response = await axios.post(`${BACKEND_URL}/reset-password/request`, { username });
            setMessage(response.data.message);
        } catch (error) {
            setMessage(error.response?.data?.error || t('xAuth.errorOccurred'));
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setUsername(e.target.value);
    };

    return (
        <div>
            <Helmet>
                {/* Add Font Awesome stylesheet */}
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
                />
            </Helmet>
            <div className="header-container">
                <img src={logo} alt={t('xAuth.logoAlt')} className="logo" />
                <span className="app-name">HEVN PORTAL</span>
            </div>
            <div className="content">
                <div className="form-container" id="signIn">
                    <h1 className="form-title">{t('xAuth.forgotTitle')}</h1>
                    <form onSubmit={handleSubmit}>
                        <p className="guide-message">{t('xAuth.forgotGuide')}</p>
                        <div className="form-group">
                            <span className="w-40">{t('xAuth.username')}</span>
                            <input
                                type="text"
                                name="username"
                                id="username"
                                placeholder={t('xAuth.username')}
                                value={username}
                                onChange={handleChange}
                                className="form-field"
                                required
                            />
                        </div>
                        {error && (
                            <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                                {error}
                            </div>
                        )}
                        <div className="btn-container">
                            <button
                                type="submit"
                                className="btn"
                                disabled={loading}
                            >
                                {loading ? t('xAuth.sending') : t('xAuth.sendResetLink')}
                            </button>
                        </div>
                        {message && <p className={"success-message"}>{message}</p>}
                    </form>
                </div>
            </div>

            <style jsx="true">{`
                .form-title{
                    margin-bottom:0.1rem;
                }
                form {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .guide-message {
                    font-size: 14px;
                }
                .btn{
                    width: 75%;
                }
                // Center
            `}</style>
        </div>
    );
}

export default ResetPasswordRequest;
